import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './App.css';

import Login from './components/auth/login';
import { checkSession } from './redux/actions/authAction';

import Layout from './components/layout/layout';
import Dashboard from './components/main/dashboard';
import ItemManager from './components/main/item-manager';
import DocUpload from './components/main/doc-upload';
import PriceAnalysis from './components/main/price-analysis';
import VendorCompare from './components/main/vendor-compare';

// Pages inside the app need a session; otherwise go to the login page and come back afterwards
function RequireAuth({ children }) {
  const { user, checked } = useSelector(state => state.auth);
  const location = useLocation();
  if (!checked) return <div className="PageLoader"><i className="fa fa-spinner fa-spin"></i></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}

function App() {
  const dispatch = useDispatch();
  useEffect(() => { dispatch(checkSession()); }, [dispatch]);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/item-manager" element={<ItemManager />} />
            <Route path="/doc-upload" element={<DocUpload />} />
            <Route path="/price-analysis" element={<PriceAnalysis />} />
            <Route path="/vendor-compare" element={<VendorCompare />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
